import { useState, useEffect } from "react";
import React, { Component } from "react";
import { Wheel } from "react-custom-roulette";
import ConfettiExplosion, { ConfettiProps } from "react-confetti-explosion";
import "./App.css";
import RewardVideo from "./RewardAd";
import { Wallet } from "./Wallet";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";
import { addDoc } from "firebase/firestore";
import { serverTimestamp } from "firebase/firestore";
import { fetchData } from "./api"; // Import the function
export default function WheelOuter() {
  const [adDisplayed, setAdDisplayed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [playAnimation, setPlayAnimation] = useState(false);
  const [isExploding, setIsExploding] = useState(false);
  const [activeToken, setActiveToken] = useState("");
  const [dataLoaded, setDataLoaded] = useState(true);
  const [spinAllowed, setSpinAllowed] = useState(true);
  const [spinText, setSpinText] = useState("LOADING..");
  const [spinTime, setSpinTime] = useState(-1);
  const [timer, setTimer] = useState(false);
  const [spinFetch, setSpinFetch] = useState(false);
  const [wheelMargin, setWheelMargin] = useState(0);
  const [adDone, setAdDone] = useState(false);
  const [claimer, setClaimer] = useState(0);
  const [cloud, setCloud] = useState(global.getProfileData());
  const [spinner, setSpinner] = useState(false);
  const [retryAllowed, setRetryAllowed] = useState(false);
  const [emrBalance, setEmrBalance] = useState(0);
  const [conversionPrice, setConversionPrice] = useState(0.00041);
  const db = getFirestore(); // Initialize Firestore
  const [claiming, setClaiming] = useState(false);
  async function logAndUpdateEMRS(tgUserid, emrsToAdd, eventType) {
    try {
      const tgUseridNum = Number(tgUserid);
      await addDoc(collection(db, "telegram_emrs_log"), {
        tgUserid: tgUseridNum,
        EMRS: emrsToAdd,
        type: eventType,
        timestamp: new Date(),
      });
      console.log(
        `Log added for tgUserid ${tgUseridNum} with ${emrsToAdd} EMRS.`
      );
      const logsQuery = query(
        collection(db, "telegram_emrs_log"),
        where("tgUserid", "==", tgUseridNum)
      );
      const logsSnapshot = await getDocs(logsQuery);
      let totalEMRS = 0;
      logsSnapshot.forEach((doc) => {
        if (
          doc.data().EMRS &&
          doc.data().EMRS != null &&
          !isNaN(doc.data().EMRS)
        ) {
          totalEMRS += doc.data().EMRS;
        }
      });
      console.log(`Total EMRS for tgUserid ${tgUseridNum}: ${totalEMRS}`);
      const usersQuery = query(
        collection(db, "telegram_users"),
        where("tgUserid", "==", tgUseridNum)
      );
      const usersSnapshot = await getDocs(usersQuery);
      const updatePromises = usersSnapshot.docs.map((userDoc) => {
        return updateDoc(doc(db, "telegram_users", userDoc.id), {
          totalEMRS: totalEMRS,
          lastClaim: serverTimestamp(),
        });
      });
      await Promise.all(updatePromises);
      console.log(
        `Updated totalEMRS for all users with tgUserid ${tgUseridNum}`
      );
      setEmrBalance(totalEMRS);
      setSpinAllowed(true);
      setSpinFetch(false);
      setClaiming(false);
      if (retryAllowed) {
        setPlayAnimation(false);
        setHoursEnded(false);
        getTelegramUser(tgUserid);
      }
      setClaiming(false);
    } catch (error) {
      setClaiming(false);
      console.error("Error in logAndUpdateEMRS:", error);
    }
  }
  const addEmrsToUser = async () => {
    setClaiming(true);
    logAndUpdateEMRS(
      tgUserid,
      parseInt(data[prizeNumber].value),
      "WHEELREWARD"
    );
  };
  const playSound = () => {
    const audio = new Audio(require("./assets/wheelsound.mp3")); // Path to your sound file
    audio.play();
  };
  const data = [
    {
      option: "No Luck",
      value: 0,
      style: { textColor: "#fff" },
      short_title: "",
      long_title: "You have won xyz",
    },
    {
      option: "1000 EMRS",
      value: 1000,
      style: { textColor: "#fff" },
      short_title: "",
      long_title: "You have won xyz",
    },
    {
      option: "2000 EMRS",
      value: 2000,
      style: { textColor: "#fff" },
      short_title: "",
      long_title: "You have won xyz",
    },
    {
      option: "3000 EMRS",
      value: 3000,
      style: { textColor: "#fff" },
      short_title: "",
      long_title: "You have won xyz",
    },
    {
      option: "4000 EMRS",
      value: 4000,
      style: { textColor: "#fff" },
      short_title: "",
      long_title: "You have won xyz",
    },
    {
      option: "No Luck",
      value: 0,
      style: { textColor: "#fff" },
      short_title: "",
      long_title: "You have won xyz",
    },
    {
      option: "5000 EMRS",
      value: 5000,
      style: { textColor: "#fff" },
      short_title: "",
      long_title: "You have won xyz",
    },
    {
      option: "10,000 EMRS",
      value: 10000,
      style: { textColor: "#fff" },
      short_title: "",
      long_title: "You have won xyz",
    },
    {
      option: "50,000 EMRS",
      value: 50000,
      style: { textColor: "#fff" },
      short_title: "",
      long_title: "You have won xyz",
    },
    {
      option: "100k EMRS",
      value: 100000,
      style: { textColor: "#fff" },
      short_title: "",
      long_title: "You have won xyz",
    },
  ];
  const largeProps: ConfettiProps = {
    force: 0.8,
    duration: 3000,
    particleCount: 300,
    width: 1600,
    colors: ["#041E43", "#1471BF", "#5BB4DC", "#FC027B", "#66D805"],
  };
  const backgroundColors = [
    "#0bbcb6",
    "#40407a",
    "#ff5252",
    "#218c74",
    "#474787",
    "#ff793f",
    "#34ace0",
    "#ffb142",
  ];
  const textColors = ["#0b3351"];
  const outerBorderColor = "#474787";
  const outerBorderWidth = 0;
  const innerBorderColor = "#fff";
  const innerBorderWidth = 0;
  const innerRadius = 0;
  const radiusLineColor = "#fff";
  const radiusLineWidth = 1;
  const fontFamily = "Bungee";
  const fontWeight = "bold";
  const fontSize = 12;
  const fontStyle = "normal";
  const textDistance = 60;
  const spinDuration = 0.5;
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [previousPrize, setPreviousPrize] = useState(0);
  const handleSpinClick = () => {
    hideAdNow();
    if (!mustSpin) {
      setWheelMargin(50);
      setSpinFetch(true);
      setSpinAllowed(false);
      //      const newPrizeNumber = 1;
      const newPrizeNumber = Math.floor(Math.random() * data.length);
      setPrizeNumber(newPrizeNumber);
      setMustSpin(true);
      setTimeout(function () {
        playSound();
      }, 500);
    }
  };
  const [hoursEnded, setHoursEnded] = useState(false);
  function isTimestampToday(timestamp) {
    timestamp = timestamp * 1000;
    const inputDate = new Date(timestamp);
    const today = new Date();
    return (
      inputDate.getFullYear() === today.getFullYear() &&
      inputDate.getMonth() === today.getMonth() &&
      inputDate.getDate() === today.getDate()
    );
  }
  const retrySpin = async () => {
    setSpinner(true);
    try {
      const usersRef = collection(db, "telegram_users");
      const q = query(usersRef, where("tgUserid", "==", tgUserid));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const userDoc = querySnapshot.docs[0]; // Assuming tgUserid is unique
        const userRef = doc(db, "telegram_users", userDoc.id);
        const currentTimestamp = Math.floor(Date.now() / 1000);
        await updateDoc(userRef, { lastRetry: currentTimestamp });
        setRetryAllowed(false);
        setSpinAllowed(true);
        setSpinFetch(false);
        setPlayAnimation(false);
        getTelegramUser(tgUserid);
      } else {
        setSpinner(false);
        console.log("No user found with tgUserid =", tgUserid);
      }
    } catch (error) {
      setSpinner(false);
      console.error("Error updating totalEmrs:", error);
    }
  };



  async function checkWheelCoolDown(tgUserId){
    

    const res = await fetch(
      `https://us-central1-emorya-gcp.cloudfunctions.net/checkSpinCooldown?tgUserId=${tgUserId}`
    );
    
    const data = await res.json();

    console.log(data);
    
    if (data.spinAllowed) {
      setSpinAllowed(true);
      setHoursEnded(true);
    } else {
      setSpinAllowed(false);
      setHoursEnded(false);
      setSpinTime(data.spinTime);
      setTimer(true);
    }
  }


  async function getTelegramUser(tgUserid) {
    try {
      const q = query(
        collection(db, "telegram_users"),
        where("tgUserid", "==", tgUserid)
      );
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const userData = querySnapshot.docs[0].data();
        console.log("User Data:", userData);
        setCloud({ ...cloud, userData: userData });
        setEmrBalance(userData.totalEMRS);
        if (!userData.lastRetry) {
          setRetryAllowed(true);
        } else {
          if (isTimestampToday(userData.lastRetry)) {
            setRetryAllowed(false);
          } else {
            console.log("old teimstamp");
            setRetryAllowed(true);
          }
        }
        setSpinner(false);
        checkWheelCoolDown(tgUserid);
        //checkWheelCoolDown(6102230730)
        // if (userData.lastClaim) {
        //   const lastUpdatedTime = userData.lastClaim.toDate(); 
        //   const lastUpdatedTimestamp = new Date(
        //     lastUpdatedTime.getTime() + (6 * 60 * 60 * 1000)
        //   );
        //   const currentTime = new Date();
        //   if (lastUpdatedTimestamp > currentTime) {
        //     setHoursEnded(false);
        //     const differenceInSeconds = Math.abs(
        //       (currentTime - lastUpdatedTimestamp) / 1000
        //     ); 
        //     setSpinTime(differenceInSeconds);
        //     setTimer(true);
        //   } else {
        //     setSpinAllowed(true);
        //     setHoursEnded(true);
        //   }
        // } else {
        //   setSpinAllowed(true);
        //   setHoursEnded(true);
        // }
        setLoading(false);
        return userData;
      } else {
        console.log("No user found with tgUserid:", tgUserid);
        return null;
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      return null;
    }
  }
  const updateTimer = () => {};
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      console.log(spinTime);
      if (timer == false || spinTime == -1) {
        return false;
      }
      var t = spinTime;
      t = t - 1;
      if (t <= 0) {
        getTelegramUser(tgUserid);
        setSpinAllowed(true);
        setSpinTime(-1);
        setTimer(false);
      } else {
        setSpinTime(t);
        var hours = Math.floor(t / 3600); // 1 hour = 3600 seconds
        var minutes = Math.floor((t % 3600) / 60); // Remaining minutes after hours are extracted
        var seconds = parseInt(t % 60);
        if (seconds < 10) seconds = "0" + seconds;
        if (minutes < 10) minutes = "0" + minutes;
        if (hours < 10) hours = "0" + hours;
        setSpinText(`${hours} : ${minutes} : ${seconds}`);
      }
    }, 1000); // 3 seconds
    // Cleanup the timeout when the component unmounts
    return () => clearTimeout(timeoutId);
  }, [spinTime]);
  useEffect(() => {
    updateTimer();
  }, [timer]);
  const [tgUserid, setTgUserId] = useState(0);
  useEffect(() => {
    setTgUserId(parseInt(localStorage.getItem("TGUSERID")));
    getTelegramUser(parseInt(localStorage.getItem("TGUSERID")));
  }, []);
  useEffect(() => {
    const getData = async () => {
      const response = await fetchData("https://api.emorya.com/emrs-price");
      console.log(response);
      if (response) {
        var price = response[0].usdPrice;
        console.log(price);
        setConversionPrice(price);
      }
    };
    getData();
  }, []);
  const showAds = () => {
    setAdDisplay(true);
  };
  const hideAdNow = () => {
    setAdDisplay(false);
  };
  const [adDisplay, setAdDisplay] = useState(false);
  return (
    <>
      {adDisplay ? (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.8)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 200000,
            }}
          >
            <RewardVideo
              callBack={handleSpinClick}
              callBackArgs={""}
            ></RewardVideo>
          </div>
        </>
      ) : null}
      <div className="section wheelBack1">
        <div
          style={{
            padding: 20,
            textAlign: "left",
            width: "100%",
            position: "relative",
          }}
        >
          <div
            style={{
              padding: 20,
              marginTop: 40,
              textAlign: "center",
            }}
          >
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                console.log('Logout From 16');
                global.goToSignIn();
              }}
              style={{
                padding: "5px 15px",
                borderRadius: 20,
                marginTop: 0,
                width: "auto",
                fontSize: 12,
                backgroundColor: "#4b2b55",
                display: "none",
              }}
            >
              Get started with 1000 $EMRS instantly!
            </button>
          </div>
          <div
            className="animate__animated animate__flipInX"
            style={{
              position: "fixed",
              top: 20,
              right: 20,
              zIndex: 30,
            }}
          >
            <button
              className="btn btn-primary gradColor"
              onClick={() => {
                global.downloadApplication();
              }}
              style={{
                padding: "5px 15px",
                borderRadius: 20,
                fontSize: 13,
              }}
            >
              Balance: {emrBalance} EMRS (${" "}
              {(emrBalance * conversionPrice).toFixed(2)})
            </button>
          </div>
          <div
            style={{
              position: "absolute",
              top: 60,
              width: "100%",
              height: 350,
              left: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          ></div>
          <div
            style={{
              marginTop: wheelMargin,
              textAlign: "center",
              transition: "margin-top 0.5s ease", // Animate directly in style
            }}
          >
            {dataLoaded ? (
              <>
                <Wheel
                  mustStartSpinning={mustSpin}
                  prizeNumber={prizeNumber}
                  data={data}
                  backgroundColors={backgroundColors}
                  textColors={textColors}
                  fontFamily={fontFamily}
                  fontSize={fontSize}
                  fontWeight={fontWeight}
                  fontStyle={fontStyle}
                  outerBorderColor={outerBorderColor}
                  outerBorderWidth={outerBorderWidth}
                  innerRadius={innerRadius}
                  innerBorderColor={innerBorderColor}
                  innerBorderWidth={innerBorderWidth}
                  radiusLineColor={radiusLineColor}
                  radiusLineWidth={radiusLineWidth}
                  spinDuration={spinDuration}
                  startingOptionIndex={previousPrize}
                  // perpendicularText
                  textDistance={textDistance}
                  onStopSpinning={() => {
                    setMustSpin(false);
                    setPlayAnimation(true);
                    setWheelMargin(0);
                    if (!retryAllowed && data[prizeNumber].value > 0) {
                      addEmrsToUser();
                    }
                  }}
                />
              </>
            ) : (
              <></>
            )}
            {playAnimation ? (
              <>
                <div
                  className="winTag"
                  style={{
                    marginTop: 10,
                  }}
                >
                  <div className="animate__animated animate__zoomInUp">
                    <div
                      className="glitch-wrapper"
                      style={{
                        width: "100%",
                        height: 40,
                        backgroundColor: "transparent",
                      }}
                    >
                      <div
                        className="glitch"
                        data-glitch={data[prizeNumber].option}
                        style={{
                          fontSize: 40,
                        }}
                      >
                        <span
                          style={{
                            color: "#eaac3b",
                          }}
                        >
                          {data[prizeNumber].option}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        fontSize: 20,
                      }}
                    >
                      {data[prizeNumber].option.indexOf("Luck") == -1 ? (
                        <>
                          <div
                            style={{
                              color: "#eaac3b",
                              marginTop: 10,
                            }}
                          >
                            You have won {data[prizeNumber].option}. Download
                            the Emorya App now and start monetizing your
                            winnings.
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {data[prizeNumber].option.indexOf("No Luck") == -1 ? (
                      <>
                        <ConfettiExplosion {...largeProps} />
                        <div className="row animate__animated animate__zoomInUp">
                          <div className="col-12">
                            <div
                              className="button"
                              onClick={() => {
                                retrySpin();
                              }}
                              style={{
                                borderRadius: 5,
                                backgroundColor: backgroundColors[prizeNumber],
                                marginLeft: 0,
                                marginRight: 10,
                                display:
                                  claiming || !retryAllowed
                                    ? "none"
                                    : "inline-block",
                              }}
                            >
                              <a
                                href="#"
                                style={{
                                  backgroundColor:
                                    backgroundColors[prizeNumber],
                                  boxShadow: "none",
                                  textAlign: "center",
                                }}
                              >
                                <i
                                  className={
                                    spinner
                                      ? "fa-spin fa-solid fa-rotate-right "
                                      : "fa-solid fa-rotate-right "
                                  }
                                ></i>
                              </a>
                            </div>
                            <div
                              className="button animate__animated animate__zoomInUp"
                              onClick={() => {
                                //                                global.goToSignIn();
                                // setClaimer(data[prizeNumber].value);
                                if (!claiming) {
                                  addEmrsToUser();
                                }
                              }}
                              style={{
                                borderRadius: 5,
                                backgroundColor: backgroundColors[prizeNumber],
                                marginLeft: 10,
                                marginRight: 0,
                                display:
                                  claiming || !retryAllowed
                                    ? "none"
                                    : "inline-block",
                              }}
                            >
                              <a
                                href="#"
                                style={{
                                  backgroundColor:
                                    backgroundColors[prizeNumber],
                                  boxShadow: "none",
                                }}
                              >
                                {claiming ? "Claiming.." : "Claim"}
                              </a>
                            </div>
                            <div
                              className="button animate__animated animate__zoomInUp"
                              onClick={() => {
                                global.goToSignIn();
                              }}
                              style={{
                                borderRadius: 5,
                                backgroundColor: backgroundColors[prizeNumber],
                                marginLeft: 10,
                                marginRight: 0,
                                display:'none'
                              }}
                            >
                              <a
                                href="#"
                                style={{
                                  backgroundColor:
                                    backgroundColors[prizeNumber],
                                  boxShadow: "none",
                                }}
                              >
                                MONETIZE
                              </a>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className="button animate__animated animate__zoomInUp"
                          onClick={() => {
                            setPlayAnimation(false);
                            setSpinAllowed(true);
                          }}
                          style={{
                            borderRadius: 5,
                            backgroundColor: backgroundColors[prizeNumber],
                          }}
                        >
                          <a
                            href="#"
                            style={{
                              backgroundColor: backgroundColors[prizeNumber],
                              boxShadow: "none",
                            }}
                          >
                            <i className="fa-solid fa-rotate-right"></i>
                          </a>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                {hoursEnded ? (
                  <>
                    <div
                      className="button animate__animated animate__zoomInUp"
                      onClick={() => {
                        showAds();
                      }}
                      style={{
                        display: spinAllowed ? "" : "none",
                      }}
                    >
                      <a href="#">SPIN</a>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="button animate__animated animate__zoomInUp"
                      onClick={() => {
                        //                  handleSpinClick();
                      }}
                      style={{
                        display: spinAllowed ? "none" : "",
                      }}
                    >
                      <a href="#">{spinText}</a>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
        <div
          style={{
            height: 300,
          }}
        ></div>
      </div>
    </>
  );
}
